// extracted by mini-css-extract-plugin
module.exports = {"attention":"L_cW"};